module.exports = __webpack_public_path__ + "img/plus.46865210.svg";